import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';

// Enable React strict mode in development
const StrictModeWrapper = ({ children }: { children: React.ReactNode }) => {
  if (process.env.NODE_ENV === 'development') {
    return <React.StrictMode>{children}</React.StrictMode>;
  }
  return <>{children}</>;
};

// Create root and render app
const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container not found');
}

const root = ReactDOM.createRoot(container);

root.render(
  <StrictModeWrapper>
    <App />
  </StrictModeWrapper>
);

// Hot module replacement for development
if (import.meta.hot) {
  import.meta.hot.accept('./App', () => {
    // Re-render the app when App component changes
    root.render(
      <StrictModeWrapper>
        <App />
      </StrictModeWrapper>
    );
  });
}

// Performance monitoring
if ('performance' in window && 'mark' in performance) {
  performance.mark('app-render-start');

  // Mark when React has finished initial render
  setTimeout(() => {
    performance.mark('app-render-end');
    performance.measure('app-render', 'app-render-start', 'app-render-end');

    const measure = performance.getEntriesByName('app-render')[0];
    if (measure) {
      console.log(`React app render time: ${measure.duration.toFixed(2)}ms`);
    }
  }, 0);
}

// Service worker registration for PWA capabilities
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}
